import React, { useEffect, useLayoutEffect, useState } from "react";
import airconService from "../services/aircon.service";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
import clientService from "../services/client.service";
import authsService from "../services/auths.service";
import clientcategoryService from "../services/clientcategory.service";
const Aircon = () => {
  const userinfo = authsService.userinfo();
  const userinfos = authsService.userdata();
  const client_id = authsService.getclientname();
  /* const client_id = localStorage.getItem('selectedclient'); */

  let navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState(false);

  const [aircons, setAircons] = useState([]);
  const [result, setResult] = useState([]);
  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState("");
  const [filterclient, setFilterclient] = useState(
    client_id === "democlient" ? "" : client_id
  );
  const [filterblock, setFilterblock] = useState("");
  const [filterlevel, setFilterlevel] = useState("");
  const [filterlocation, setFilterlocation] = useState("");


  const [filterclientarr, setFilterclientarr] = useState([]);
  const [buildingarr, setBuildingarr] = useState([]);
  const [blockarr, setBlockarr] = useState([]);
  const [levelarr, setLevelarr] = useState([]);
  const [locationarr, setLocationarr] = useState([]);

  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("");
  const [group, setGroup] = useState("");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "aircon ID", value: "" },
    /*   { label: "Client", value: "" }, */
    { label: "Type", value: "" },
    { label: "Block", value: "" },
    { label: "Level", value: "" },
    { label: "location", value: "aircon_location" },
    { label: "Unit", value: "total_unit" },
    { label: "Status", value: "" },
    { label: "Created", value: "createdAt" },
    { label: "action", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);
  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };

  //use effects
  useEffect(() => {
    console.log('sdsd', client_id);
    getallAircon();
    getallClient();
    getallblock();
    getalllevel();
    getalllocation();
    getallbuilding();
  }, []);
  useLayoutEffect(() => {
    getallAircon();
  }, [page, limit, filter, filterclient, filterblock, filterlevel, filterlocation, search, between, sort]);

/*   useLayoutEffect(() => {
    getallAircon();
  }, [client_id]); */
  //get allaircon
  const getallAircon = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      filterclient:filterclient,
      filterblock: filterblock,
      filterlevel: filterlevel,
      filterlocation: filterlocation,
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await airconService
      .getallAircon(data)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          setAircons(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          console.log(res.data);
        } else {
          setIsmessage(res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterclientArr, setfilterclientArr] = useState([]);
  const filterclientfn = (value) => {
    setPage(1);
    var index = filterclientArr.indexOf(value);
    if (index > -1) {
      filterclientArr.splice(index, 1);
      setFilterclient(filterclientArr.toString());
    } else {
      filterclientArr.push(value);
      setFilterclient(filterclientArr.toString());
    }
  };
  //filter block
  const [filterblockArr, setfilterblockArr] = useState([]);
  const filterblockfn = (value) => {
    setPage(1);
    var index = filterblockArr.indexOf(value);
    if (index > -1) {
      filterblockArr.splice(index, 1);
      setFilterblock(filterblockArr.toString());
    } else {
      filterblockArr.push(value);
      setFilterblock(filterblockArr.toString());
    }
  };
  //filter level
  const [filterlevelArr, setfilterlevelArr] = useState([]);
  const filterlevelfn = (value) => {
    setPage(1);
    var index = filterlevelArr.indexOf(value);
    if (index > -1) {
      filterlevelArr.splice(index, 1);
      setFilterlevel(filterlevelArr.toString());
    } else {
      filterlevelArr.push(value);
      setFilterlevel(filterlevelArr.toString());
    }
  };
  //filter location
  const [filterlocationArr, setfilterlocationArr] = useState([]);
  const filterlocationfn = (value) => {
    setPage(1);
    var index = filterlocationArr.indexOf(value);
    if (index > -1) {
      filterlocationArr.splice(index, 1);
      setFilterlocation(filterlocationArr.toString());
    } else {
      filterlocationArr.push(value);
      setFilterlocation(filterlocationArr.toString());
    }
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort === value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort === value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };
  //between

  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
      " , " +
      format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };

  //get allclient
  const getallClient = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientService
      .getallClient(data)
      .then((res) => {
        if (res.data.result) {
          setFilterclientarr(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };

  //get block
  const getallblock = async () => {
    var data = {
      limit: 500,
      page: 1,
      filter: "",
      filterclient: filterclient,
      filtercategory: "block",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setBlockarr(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get block
  const getalllocation = async () => {
    var data = {
      limit: 500,
      page: 1,
      filter: "",
      filterclient: filterclient,
      filtercategory: "location",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setLocationarr(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get level
  const getalllevel = async () => {
    var data = {
      limit: 500,
      page: 1,
      filter: "",
      filterclient: filterclient,
      filtercategory: "level",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setLevelarr(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get building
  const getallbuilding = async () => {
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      filterclient: filterclient,
      filtercategory: "building",
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setBuildingarr(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  const selectedcolor = (value) => {
    if (value === "active") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "inactive") {
      return "badge rounded-pill bg-danger";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  // Call aircon clicks to request another page.
  if (ismessage == "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  /* if (isLoaded == true) {
    return <Loader />
  } */

  return (
    <div className="">
      <div className="text-center">
        {/*  loader and error handler */}
        {isLoaded ? <Loader /> : <></>}
      </div>
      {/*  container */}
      <div className="aircon-container">
        {/* <h5>Aircon list</h5> */}
        <div>
          <div className="d-flex  mb-2 ">
            <h1 className="flex-fill">All Aircon</h1><div><button
              onClick={() => {
                navigate("/airconevent");
              }}
              type="submit"
              className="btn btn-primary"
            >
              <i className="fa fa-plus"></i> Add Aircon
            </button></div>
          </div>
        </div>
        {/* tebale header part search,filter,sort */}
        <div className="d-md-flex ">
          {/* create aircon */}
          <div className="d-none">
            <button style={{ borderLeft: "7px solid black" }} className={
              userinfos.login_type === "dashboard" ? "d-none" : "btn m-1 btn-outline-white"
            }>LIST OF AIRCONS</button>
          </div>
          <div
            className="d-none"
          /*  className={
             userinfos.login_type === "dashboard"
               ? "d-md-flex  mb-2"
               : "d-none"
           } */
          >
            {/* <div className="m-1">
              <button
                onClick={() => {
                  navigate("/airconevent");
                }}
                type="submit"
                className="btn btn-primary  w-100"
              >
                <i className="fa fa-plus-circle"></i> Create
              </button>
            </div> */}
            {/* filter status*/}
            <div className="dropdown m-1 d-none">
              <button
                className="btn btn-primary w-100 dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa fa-filter" aria-hidden="true"></i> Status
              </button>
              <ul
                style={{ minWidth: 200 }}
                className="dropdown-menu p-2"
                aria-labelledby="dropdownMenuButton1"
              >
                <li className="text-secondary">Aircon Status</li>
                {filterarray.map((filterdata, index) => (
                  <li key={index}>
                    <div className="form-check">
                      <input
                        onChange={(e) => filterfn(filterdata.status_name)}
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      ></input>
                      <label
                        className="form-check-label text-dark"
                        htmlFor="flexCheckDefault"
                      >
                        {filterdata.status_name}
                      </label>
                    </div>
                  </li>
                ))}
                <li></li>
              </ul>
            </div>
          </div>

          {/* filter client   userinfos.login_type === "dashboard" ? "dropdown m-1" : "d-none"*/}
          <div className={userinfos.login_type === "dashboard" ? "dropdown m-1" : "d-none"}>
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Client
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Client</li>
              {filterclientarr.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterclientfn(filterdata.client_id)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.client_fullname}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/*  block filter */}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Block
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Block</li>
              {blockarr && blockarr.map((blockarr, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterblockfn(blockarr.category_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {blockarr.category_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/*  level filter */}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Level
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Level</li>
              {levelarr && levelarr.map((levelarr, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterlevelfn(levelarr.category_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {levelarr.category_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/*  location filter */}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Unit or Location
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Unit or Location</li>
              {locationarr && locationarr && locationarr.map((locationarr, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterlocationfn(locationarr.category_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {locationarr.category_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/* search */}
          <div className={
            userinfos.login_type != "dashboard" ? "m-1 ms-auto" : "m-1"
          } >
            <input
              className="form-control"
              onChange={searchfn}
              placeholder="search by Id or Location"

              type="search"
            ></input>
          </div>
          {/*  date range  */}
          <div className={
            userinfos.login_type === "dashboard" ? "m-1 ms-auto" : "d-none"
          }>
            <div className="btn-group" role="group">
              {between ? (
                <button
                  type="button"
                  className="btn bg-white border me-1 "
                  onClick={resetbetweenfn}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
              ) : (
                <></>
              )}
              <button
                className="btn bg-white border dropdown-toggle"
                id="dropdownMenuClickableInside"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="fa fa-calendar" aria-hidden="true"></i> {between}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuClickableInside"
              >
                <li className="">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={(date) => betweenfn(date)}
                  />
                </li>
                <li className="text-end">
                  <a onClick={resetbetweenfn} className="btn">
                    Reset
                  </a>
                  {/*  <a data-bs-dismiss="dropdown"  className="btn">Okay</a> */}
                </li>
              </ul>
            </div>
          </div>
          {/* between */}
          {/*  <div className="m-1">
                        <input
                            id="betweenstart"
                            className="form-control"
                            value={betweenstart}
                            onChange={(e) => betweenfn("start", e.target.value ? e.target.value : '')}
                            placeholder="start"
                            type="date"
                        ></input>
                    </div>
                    <div className="m-1">
                        <input
                            id="betweenend"
                            className="form-control"
                            value={betweenend}
                            onChange={(e) => betweenfn("end", e.target.value)}
                            placeholder="start"
                            type="date"
                        ></input>
                    </div> */}
        </div>
        <div className="mb-1">
          {/*  &nbsp; Filter By : &nbsp;&nbsp; */}
          {filterblockArr.length ? <>
            {filterblockArr.map((filterblockArr, i) => (
              <span key={i} className="badge bg-secondary"><i className="fa fa-times-circle-o"></i> {filterblockArr} </span>
            ))}
          </> : <></>}&nbsp;&nbsp;
          {filterlevelArr.length ? <>
            {filterlevelArr.map((filterlevelArr, i) => (
              <span key={i} className="badge bg-secondary"><i className="fa fa-times-circle-o"></i> {filterlevelArr} </span>
            ))}
          </> : <></>}&nbsp;&nbsp;
          {filterlocationArr.length ? <>
            {filterlocationArr.map((filterlocationArr, i) => (
              <span key={i} className="badge bg-secondary"><i className="fa fa-times-circle-o"></i> {filterlocationArr} </span>
            ))}
          </> : <></>}
        </div>
        {/* table section*/}
        <div className="table-responsive card bg-white border-0 mb-2">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                {tableHeaders.map((data, index) => (
                  <th key={index} scope="col">
                    {data.label}
                    {/* table sort */}
                    {data.value != "" ? (
                      <a
                        onClick={() => sortfn(data.value)}
                        className="btn btn-sm"
                      >
                        <span
                          className={
                            sort === data.value + " asc"
                              ? "text-dark"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          <i className="fa fa-long-arrow-up"></i>
                        </span>
                        <span
                          className={
                            sort === data.value + " desc"
                              ? "text-dark"
                              : "text-secondary"
                          }
                        >
                          <i className="fa fa-long-arrow-down"></i>
                        </span>
                      </a>
                    ) : (
                      <></>
                    )}
                  </th>
                ))}
                {/* <th scope="col">#</th>
                <th scope="col">aircon name</th>
                <th scope="col">Status</th>
                <th style={{ width: 100 }} scope="col">
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody>
              {/* table data */}
              {aircons ? (
                <>
                  {aircons.map((data, index) => (
                    <tr key={index}>
                      <td>{data.aircon_id}</td>
                      {/* <td>{data.client_id}</td> */}
                      <td>{data.aircon_type}</td>
                      <td style={{ minWidth: 100 }}>{data.aircon_block}</td>
                      <td style={{ minWidth: 100 }}>{data.aircon_level}</td>
                      <td style={{ minWidth: 150 }}>{data.aircon_location}</td>
                      <td style={{ minWidth: 110 }}>{data.total_unit}</td>
                      <td>
                        <span className={selectedcolor(data.aircon_status)}>
                          {data.aircon_status}
                        </span>
                      </td>
                      <td style={{ minWidth: 150 }}>{format(new Date(data.createdAt), "PPpp")}</td>
                      <td className="p-1 m-0">
                        {userinfo.login_type === "client" ? (
                          <>
                            <Link
                              className="btn btn-light me-2"
                              to={"/airconview?aircon_id=" + data.aircon_id}
                            >
                              <i className="fa fa-eye" aria-hidden="true"></i>
                            </Link>
                          </>
                        ) : (
                          <>
                            <Link
                              className="btn btn-light me-2"
                              to={"/airconevent?aircon_id=" + data.aircon_id}
                            >
                              <i className="fa fa-eye" aria-hidden="true"></i>
                            </Link>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan={10} className="text-center">
                    <div className="text-center p-3">0 data found</div>
                  </td>
                </tr>
              )}
            </tbody>
            <caption className="">
              <div className="d-flex">
                <div className="flex-fill"></div>
                <div className="p-1 "> Items per page </div>
                <div>
                  {" "}
                  <select
                    value={limit}
                    onChange={(e) => {
                      setLimit(e.target.value);
                      setPage(1);
                    }}
                    className="form-select form-select-sm"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                  </select>
                </div>
                <div className="p-1 me-4">
                  {page * limit - limit}-{page * limit} of {resultCount}
                </div>
                <ReactPaginate
                  previousLabel="< Prev"
                  nextLabel="Next >"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={pagecount}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={3}
                  onPageChange={paginationfn}
                  containerClassName="pagination"
                  activeClassName="actives"
                  disabledLinkClassName="text-secondary"
                  forcePage={page - 1}
                />
              </div>
            </caption>
          </table>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Aircon;
